import gql from 'graphql-tag';

export default
gql `mutation updateUser($input: UpdateUserInput!){
		updateUser(input:$input){
			id
			username
			email
			goals
			voicePursuit
			gender
			Age
			voiceType
			voiceDescriptives
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/UpdateUserMutation.js